import { CONFIG } from "../../config";
import * as THREE from "three";

export const createPointMarkerMaterial = (
  color: string,
  opacity = 1,
): THREE.Material => {
  return new THREE.MeshBasicMaterial({
    color: new THREE.Color(color),
    opacity,
    transparent: opacity < 1,
  });
};

export const createPointMarker = (
  material: THREE.Material,
  radius?: number,
): THREE.Mesh => {
  const geometry = new THREE.SphereGeometry(
    radius ?? CONFIG.marker.radius,
    CONFIG.marker.segments,
    CONFIG.marker.segments,
  );

  const mesh = new THREE.Mesh(geometry, material);
  mesh.renderOrder = CONFIG.marker.renderOrder;

  return mesh;
};
